<template>
  <div>
    <CustomAlert :show-alert="submitError" alert-type="error">
      <span class="body-2">{{ submitErrorMsg }}</span>
    </CustomAlert>
    <v-row>
      <v-col class="py-0 d-flex" cols="4">
        <v-select
          id="rule"
          v-model="rule"
          :items="rules"
          :label="getContent('rule_selection')"
          outlined
          dense
          required
          @change="fetchProductionData"
        ></v-select>
      </v-col>
      <v-col class="py-0 d-flex" cols="6"> </v-col>
      <v-col class="py-0 px-0 d-flex" cols="2">
        <v-checkbox
          v-model="allChecked"
          class="justify-end"
          color="primary"
          :label="` ${allChecked ? 'alle' : 'keine'} ausgewählt`"
          @change="toggleAllCheckboxes()"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-data-table
      :footer-props="{
        'items-per-page-text': 'Datensätze pro Seite',
        'items-per-page-all-text': 'Alle',
        'page-text': '{0}-{1} von {2}'
      }"
      :headers="headers"
      :items="items"
      :items-per-page="10"
      class="elevation-1"
      :height="500"
    >
      <template #[`item.batch`]="{ item }">
        <span v-html="item.batch"></span>
      </template>
      <template #[`item.leadRegions`]="{ item }">
        <span v-html="stringifyRegions(item.leadRegions)"></span>
      </template>
      <template #[`item.sheetAmount`]="{ item }">
        <span v-html="item.sheetAmount"></span>
      </template>
      <template #[`item.weight`]="{ item }">
        <span v-html="item.weight + ' g'"></span>
      </template>
      <template #[`item.documents`]="{ item }">
        <span v-html="item.documents.length"></span>
      </template>
      <template #[`item.checked`]="{ item }">
        <v-checkbox
          v-model="item.checked"
          class="justify-end"
          color="primary"
          @change="onCheckboxChange()"
        ></v-checkbox>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import CustomAlert from '@/components/CustomAlert'
import { planningService, rulesService } from '@/services/'

export default {
  components: {
    CustomAlert
  },
  props: {
    setItems: {
      type: Function
    },
    setOrderValues: {
      type: Function
    },
    getContent: {
      type: Function
    }
  },
  data: () => ({
    content: {},
    rule: '',
    isValidationDialogOpen: false,
    validationResult: null,
    isErrorDialogOpen: false,
    items: [],
    itemsToBeSent: [],
    allChecked: true,
    submitError: false,
    submitErrorMsg: ''
  }),
  created: function() {
    // argument is cms api-endpoint
    this.generateHeaders()
    this.rules = rulesService.getRulesNameList()
  },
  methods: {
    getIndexById(id) {
      let index = null
      this.items.forEach((item, i) => {
        if (item.id === id) {
          index = i
        }
      })
      return index
    },
    stringifyRegions(regions) {
      let returnString = ''
      regions.forEach((region, i) => {
        if (i > 0) {
          returnString += ', '
        }
        returnString += region
      })
      return returnString
    },
    onCheckboxChange() {
      this.updateItemsToBeSent()
    },
    toggleAllCheckboxes() {
      this.items.forEach(item => {
        item.checked = this.allChecked
      })
      this.updateItemsToBeSent()
    },
    generateHeaders() {
      this.headers = [
        {
          text: 'Los',
          value: 'batch'
        },
        {
          text: 'Leitregionen',
          value: 'leadRegions'
        },
        {
          text: 'Blatt',
          value: 'sheetAmount',
          align: 'end'
        },
        {
          text: 'Gewicht',
          value: 'weight',
          align: 'end'
        },
        {
          text: 'Anzahl Dokumente',
          value: 'documents',
          align: 'end'
        },
        {
          text: 'ausgewählt',
          value: 'checked',
          align: 'end'
        }
      ]
    },
    fetchProductionData() {
      const selectedRule = rulesService.getRuleByName(this.rule)
      planningService
        .getRestOrderList(selectedRule)
        .then(response => {
          response.forEach(element => (element.checked = true))
          this.submitError = false
          this.items = response
          this.updateItemsToBeSent()
        })
        .catch(e => {
          this.submitError = true
          this.submitErrorMsg = this.getError(e.response.status)
        })
    },
    getError: function(errorKey) {
      return this.$store.getters.error({
        errorKey: errorKey,
        route: this.$route.name
      })
    },
    getDocumentsToBeSend() {
      const returnArray = []
      this.itemsToBeSent.forEach(item => {
        item.documents.forEach(documentId => {
          returnArray.push(documentId)
        })
      })
      return returnArray
    },
    sumUpItems(key) {
      return this.itemsToBeSent.reduce((a, b) => a + (b[key] || 0), 0)
    },
    sumUpNestedItems(key) {
      let allRegionsArray = []
      this.itemsToBeSent.forEach(itemArray => {
        itemArray[key].forEach(item => {
          if (!allRegionsArray.includes(item)) {
            allRegionsArray.push(item)
          }
        })
      })
      return allRegionsArray.length
    },
    updateItemsToBeSent: function() {
      let reducedItems = {}
      const itemsToBeSent = []
      this.items.forEach(item => {
        if (item.checked) {
          itemsToBeSent.push(item)
        }
      })
      this.itemsToBeSent = itemsToBeSent
      reducedItems.regionsAmount = this.sumUpNestedItems('leadRegions')
      reducedItems.orderDocumentsAmount = this.sumUpNestedItems('documents')
      reducedItems.orderSheetAmount = this.sumUpItems('sheetAmount')
      reducedItems.orderWeight = this.sumUpItems('weight')
      reducedItems.orderBatches = this.itemsToBeSent.length
      reducedItems.orderPartialBatches = this.sumUpItems('partialBatches')
      reducedItems.itemsToBeSent = this.itemsToBeSent
      //this.setItems(this.items)
      this.$emit('setOrderValues', reducedItems)
    },
    deleteItem: function(id) {
      let items = this.items.filter(element => element.id !== id)
      this.items = items
      this.updateItemsToBeSent()
    }
  }
}
</script>

<style></style>
